import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RenameDocumentPayload {
  id: string;
  displayName: string;
}

interface RenameLabelPayload {
  labelId: string;
  newName: string;
}

interface LabelState {
  loading: boolean;
  error: string | null;
  success: boolean;
  lastRenameLabelResponse?: any;
}

const initialState: LabelState = {
  loading: false,
  error: null,
  success: false,
  lastRenameLabelResponse: undefined,
};

const labelSlice = createSlice({
  name: "label",
  initialState,
  reducers: {
    // Document rename
    renameDocumentRequest(
      state,
      _action: PayloadAction<RenameDocumentPayload>
    ) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    renameDocumentSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.success = true;
      state.lastRenameLabelResponse = action.payload.response;
    },
    renameDocumentFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetRenameDocument(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },

    // Label rename
    renameLabelRequest(state, _action: PayloadAction<RenameLabelPayload>) {
      state.loading = true;
      state.error = null;
    },
    renameLabelSuccess(state, action: PayloadAction<{ response: any }>) {
      state.loading = false;
      state.error = null;
      state.lastRenameLabelResponse = action.payload.response;
    },
    renameLabelFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  renameDocumentRequest,
  renameDocumentSuccess,
  renameDocumentFailure,
  resetRenameDocument,
  renameLabelRequest,
  renameLabelSuccess,
  renameLabelFailure,
} = labelSlice.actions;

export default labelSlice.reducer;
